import { render, staticRenderFns } from "./orders.vue?vue&type=template&id=ab4bda88&"
import script from "./orders.vue?vue&type=script&lang=js&"
export * from "./orders.vue?vue&type=script&lang=js&"
import style0 from "./orders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab4bda88')) {
      api.createRecord('ab4bda88', component.options)
    } else {
      api.reload('ab4bda88', component.options)
    }
    module.hot.accept("./orders.vue?vue&type=template&id=ab4bda88&", function () {
      api.rerender('ab4bda88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/account/orders.vue"
export default component.exports